import React from "react";

/*
  Un renglón de casillas con su rótulo, como en el formato de papel del que salen estas
  pantallas: "SUMINISTRO: [ ] la empresa [ ] el cliente".

  Se usa en lugar de un Switch por campo porque las opciones de un grupo se leen juntas y
  no son excluyentes: puestas como switches en columnas separadas, las etiquetas largas se
  truncan y el usuario pierde de vista que pertenecen al mismo renglón.

  Los hijos son <FormItem noStyle valuePropName="checked"><CheckItem>Texto</CheckItem></FormItem>.
*/
const GrupoCasillasItem = ({ label, children, style }) => (
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "baseline",
      gap: "6px 18px",
      padding: "8px 0",
      ...style,
    }}
  >
    {label && (
      <span style={{ fontSize: 13, color: "#595959", minWidth: 130 }}>{label}</span>
    )}
    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "6px 20px" }}>
      {children}
    </div>
  </div>
);

export default GrupoCasillasItem;
